/* eslint-disable react/prop-types */
import { CheckCircleOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Spin,
  message,
} from 'antd';
import { getEstadosGlobales } from 'api/catalogos/index';
import {
  autorizarPercepcionISSSTE,
  deletePercepcionISSSTE,
  getPercepcionesISSSTE,
  patchPercepcionISSSTE,
  postPercepcionISSSTE,
} from 'api/catalogos/PercepcionesISSSTE';
import { checkToken } from 'api/utils';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import Table from 'components/Table';
import React, { useEffect, useState } from 'react';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import { NOMBRES_PATTERN } from 'utils/patterns';
// import { getTiposDeSeguridadSocial } from 'api/catalogos/tipoDeSeguridadSocial';
import { getDiasDePagoCalculo } from 'api/catalogos/DiasDePagoParaCalculo';
import { getTiposDeSueldos } from 'api/catalogos/tiposDeSueldos';
import { getValoresParaFactor } from 'api/catalogos/ValorParaFactor';
import { getPercepciones } from 'api/nominas/percepciones/percepciones';

export const PercepcionISSSTEPermission = {
  permissionModel: 'percepcionissste',
};

const PercepcionISSSTE = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [disableFields, setDisableFields] = useState(false);
  const [tiposPercepcion, setTiposPercepciones] = useState([]);
  const [, setTiposSueldos] = useState([]);
  const [, setValorFactor] = useState([]);
  const [diasPago, setDiasPago] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    const _data = await getPercepcionesISSSTE();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _data,
        _tiposPercepcion,
        _tiposSueldo,
        _valorFactor,
        _diasPago,
      ] = await Promise.all([
        getEstadosGlobales(),
        getPercepcionesISSSTE(),
        getPercepciones(),
        getTiposDeSueldos(),
        getValoresParaFactor(),
        getDiasDePagoCalculo(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setTiposPercepciones(_tiposPercepcion);
        setTiposSueldos(_tiposSueldo);
        setData(formatReceived(_data));
        setValorFactor(_valorFactor);
        setDiasPago(_diasPago);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    // setData([]);
  };

  const onClickEdit = async () => {
    setLoading(true);
    const [key] = selectedRowKeys;
    if (!([1].includes(key))) {
      const match = data?.find((item) => item.id === key);
      setTimeout(() => {
        if (match) {
          setTimeout(() => {
            form.setFieldsValue(formatReceived(match));
            setDisableFields(match?.estados_globales !== ESTATUS_ACTIVO);
            setVisible(true);
          });
        }
      });
    } else {
      message.warn('Este Registro no es editable');
    }
    setLoading(false);
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;
      const saved = await (key ? patchPercepcionISSSTE(key, values) : postPercepcionISSSTE(values));
      if (saved) {
        onCancel();
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deletePercepcionISSSTE(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una percepción ya autorizada');
        return;
      }
      const saved = await autorizarPercepcionISSSTE(key);
      if (saved) {
        const _data = await getPercepcionesISSSTE();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Percepción',
      dataIndex: 'percepcion',
      key: 'percepcion',
      width: 400,
      /*
      render: (val) => {
        const resultado = tiposPercepcion.find((e) => e.id === val);
        return resultado?.clave ;
      }, */
      render: (val) => {
        const tipo = tiposPercepcion.find((e) => e.id === val);
        return tipo ? `${tipo.clave} - ${tipo.descripcion}` : 'No encontrada';
      },
    },
    {
      titleText: 'Días Para  Cálculo',
      dataIndex: 'dias_para_calculo',
      key: 'dias_para_calculo',
      render: (val) => diasPago.find((e) => e.id === val)?.dias || 'No encontrada',
      width: 400,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    nombre: [
      requiredRule,
      {
        pattern: NOMBRES_PATTERN,
        message: 'Ingrese un nombre válido',
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          customActions={[
            {
              onClick: () => setVisibleAutorizar(true),
              permission: { model: 'percepcionissste', action: 'autorizar' },
              icon: <CheckCircleOutlined />,
              text: 'Autorizar',
              disabledBySelection: true,
              disabled: selectedData?.estados_globales !== ESTATUS_ACTIVO,
              className: 'success',
            },
          ]}
          disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO}
          permission={permission}
          allowExportPDF={false}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Percepciones ISSSTE`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              allowSave={!disableFields}
            />
            )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="general"
            initialValues={{
              estados_globales: ESTATUS_ACTIVO,
            }}
          >
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="percepcion"
                label="Percepción"
                rules={rules.required}
                hasFeedback
              >
                <Select
                  labelProp="label"
                  keyProp="id"
                  dataSource={tiposPercepcion.map((item) => ({
                    ...item,
                    label: `${item.clave} - ${item.descripcion}`,
                  }))}
                  allowClear
                  placeholder="Seleccione una percepción"
                />

              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="dias_para_calculo"
                label="Días Para  Cálculo"
                rules={rules.required}
                hasFeedback
              >
                <Select
                  labelProp="dias"
                  keyProp="id"
                  dataSource={diasPago}
                  allowClear
                  placeholder="Seleccione un Tipo"
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="estados_globales"
                label="Estatus"
                rules={rules.required}
                hasFeedback
              >
                <Select
                  labelProp="descripcion"
                  keyProp="id"
                  dataSource={estados}
                  disabled={selectedRowKeys.length <= 0 || disableFields}
                />
              </Form.Item>
            </Col>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content="El Registro Seleccionado"
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => setVisibleAutorizar(false)}
          contentTitle="Autorizar  La Percepción "
          open={visibleAutorizar}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={() => setVisibleConfirmInactivo(false)}
          ConfirmInactive
          onCancel={() => {
            form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
            setVisibleConfirmInactivo(false);
          }}
          open={visibleConfirmInactivo}
          contentTitle="Inactivar  La Percepción  "
          loading={loading}
        />
      </Spin>
    </Row>
  );
};
export default PercepcionISSSTE;
